import * as PropertyTypes from 'customer-data-objects/property/PropertyTypes';
import { __ANY_PAGE } from '../converters/listSegClassic/ListSegConstants';
import { EVENT_BASED_FIELD_KEYS } from '../strategy/eventBasedFilters';
import { useConditionRefinementChange } from './useConditionRefinementChange';
import { useEffect, useState } from 'react';
import { useFormSubmissionFilter } from './useFormSubmissionFilter';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormNotFilledOut from '../filterQueryFormat/operator/FormNotFilledOut';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
export const useConditionRefinement = (condition, emptyRefinementCondition, filterFamily, onConditionChange) => {
  var _emptyRefinementCondi, _emptyRefinementCondi2, _condition$dateRefine, _emptyRefinementCondi3, _emptyRefinementCondi5, _condition$dateRefine2, _condition$numberRefi;
  const isDateRefinementDefined = !!condition.dateRefinement;
  const isNumberRefinement = ((_emptyRefinementCondi = emptyRefinementCondition.field) === null || _emptyRefinementCondi === void 0 ? void 0 : _emptyRefinementCondi.type) === PropertyTypes.NUMBER;
  const isNumberRefinementDefined = !!condition.numberRefinement;
  const isPageLocationRefinement = ((_emptyRefinementCondi2 = emptyRefinementCondition.field) === null || _emptyRefinementCondi2 === void 0 ? void 0 : _emptyRefinementCondi2.name) === EVENT_BASED_FIELD_KEYS.EVENT_PAGE;
  const isPageLocationRefinementDefined = condition.value !== __ANY_PAGE || !!condition.isPageSelected;
  const {
    onRefinementDelete,
    onRefinementOperatorChange,
    onRefinementValueChange
  } = useConditionRefinementChange(filterFamily, condition, onConditionChange, isNumberRefinement ? PropertyTypes.NUMBER : PropertyTypes.DATE, emptyRefinementCondition);
  const {
    pageCondition,
    onPageChange,
    onPageDelete
  } = useFormSubmissionFilter(condition, onConditionChange);
  const [isChecked, setIsChecked] = useState(false);
  useEffect(() => {
    if (isPageLocationRefinement) {
      setIsChecked(isPageLocationRefinementDefined);
    } else {
      if (isNumberRefinement) {
        setIsChecked(isNumberRefinementDefined);
      } else {
        setIsChecked(isDateRefinementDefined);
      }
    }
  }, [(_condition$dateRefine = condition.dateRefinement) === null || _condition$dateRefine === void 0 || (_condition$dateRefine = _condition$dateRefine.field) === null || _condition$dateRefine === void 0 ? void 0 : _condition$dateRefine.type, (_emptyRefinementCondi3 = emptyRefinementCondition.field) === null || _emptyRefinementCondi3 === void 0 ? void 0 : _emptyRefinementCondi3.type, isDateRefinementDefined, isNumberRefinement, isNumberRefinementDefined, isPageLocationRefinement, isPageLocationRefinementDefined]);
  const isCurrentRefinement = refinement => {
    var _refinement$field, _emptyRefinementCondi4;
    return ((_refinement$field = refinement.field) === null || _refinement$field === void 0 ? void 0 : _refinement$field.type) === ((_emptyRefinementCondi4 = emptyRefinementCondition.field) === null || _emptyRefinementCondi4 === void 0 ? void 0 : _emptyRefinementCondi4.type);
  };
  const disableNumberOfSubmissionsRefinement = condition.constructor === FormNotFilledOut && ((_emptyRefinementCondi5 = emptyRefinementCondition.field) === null || _emptyRefinementCondi5 === void 0 ? void 0 : _emptyRefinementCondi5.name) === EVENT_BASED_FIELD_KEYS.EVENT_COUNT;
  const conditionErrors = condition.errors.filter(error => error.get('opts') && error.get('opts').isRefinement);
  const dateRefinementWithErrors = (_condition$dateRefine2 = condition.dateRefinement) === null || _condition$dateRefine2 === void 0 ? void 0 : _condition$dateRefine2.set('errors', condition.dateRefinement.errors.concat(conditionErrors));
  const numberRefinementWithErrors = (_condition$numberRefi = condition.numberRefinement) === null || _condition$numberRefi === void 0 ? void 0 : _condition$numberRefi.set('errors', condition.numberRefinement.errors.concat(conditionErrors));
  const refinement = isNumberRefinement ? numberRefinementWithErrors : dateRefinementWithErrors;
  const onCheckboxChange = evt => {
    const newIsChecked = evt.target.checked;
    setIsChecked(newIsChecked);
    if (!newIsChecked) {
      if (isPageLocationRefinement) {
        onPageDelete();
      } else {
        onRefinementDelete();
      }
    }
  };
  const getRefinementCondition = () => {
    if (isPageLocationRefinement && isPageLocationRefinementDefined && pageCondition) {
      return pageCondition;
    }
    if (refinement && isCurrentRefinement(refinement)) {
      return refinement;
    }
    return emptyRefinementCondition;
  };
  const getRefinementLabel = () => {
    var _emptyRefinementCondi6;
    const fieldName = emptyRefinementCondition === null || emptyRefinementCondition === void 0 || (_emptyRefinementCondi6 = emptyRefinementCondition.field) === null || _emptyRefinementCondi6 === void 0 ? void 0 : _emptyRefinementCondi6.name;
    switch (fieldName) {
      case EVENT_BASED_FIELD_KEYS.EVENT_COUNT:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'customerDataFiltersUI.customerDataFilters.FilterOperatorInput.refineByOccurrenceCount'
        });
      case EVENT_BASED_FIELD_KEYS.EVENT_DATE:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'customerDataFiltersUI.customerDataFilters.FilterOperatorInput.refineByDate'
        });
      case EVENT_BASED_FIELD_KEYS.EVENT_PAGE:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'customerDataFiltersUI.customerDataFilters.FilterOperatorInput.refineByPageLocation'
        });
      default:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'customerDataFiltersUI.customerDataFilters.FilterOperatorInput.refineBy'
        });
    }
  };
  const getTooltipText = () => {
    var _emptyRefinementCondi7;
    if (disableNumberOfSubmissionsRefinement) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: `newCustomerDataFilters.fieldDisabledTooltip.${filterFamily}.hs_event_count.FormNotFilledOut`
      });
    }
    const type = (_emptyRefinementCondi7 = emptyRefinementCondition.field) === null || _emptyRefinementCondi7 === void 0 ? void 0 : _emptyRefinementCondi7.type;
    switch (type) {
      case PropertyTypes.DATE:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: `newCustomerDataFilters.fieldDisabledTooltip.${filterFamily}.hs_event_count.dateRefinementSelected`
        });
      case PropertyTypes.NUMBER:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: `newCustomerDataFilters.fieldDisabledTooltip.${filterFamily}.hs_event_date.countRefinementSelected`
        });
      default:
        return null;
    }
  };
  const isRefinementEnabled = !disableNumberOfSubmissionsRefinement && isChecked;
  const onRefinementConditionDelete = isPageLocationRefinement ? onPageDelete : onRefinementDelete;
  const onRefinementConditionOperatorChange = isPageLocationRefinement ? emptyFunction : onRefinementOperatorChange;
  const onRefinementConditionValueChange = isPageLocationRefinement ? onPageChange : onRefinementValueChange;
  const refinementCondition = getRefinementCondition();
  const refinementLabel = getRefinementLabel();
  const tooltipText = getTooltipText();
  return {
    disableRefinement: disableNumberOfSubmissionsRefinement,
    isChecked,
    isRefinementEnabled,
    onCheckboxChange,
    onRefinementConditionDelete,
    onRefinementConditionOperatorChange,
    onRefinementConditionValueChange,
    refinementCondition,
    refinementLabel,
    tooltipText
  };
};